import React, { useEffect, useState, useCallback } from 'react';
import { Button, Modal } from 'antd';
import { injectIntl } from 'react-intl';
import { mediaHook } from 'customHooks';
import Icon from '@ant-design/icons';
import { withRouter } from 'react-router';

import { sendSegment } from 'utils/segment';

import BRContentHeader from 'components/BRContentHeader/BRContentHeader';
import { BannerContent } from 'components/Banner/Banner';
import BRButton from 'components/BRButton/BRButton';

import { ReactComponent as TeamsMemberAnnouncementBanner } from 'assets/images/teamsMemeberAnnouncement.svg';
import { ReactComponent as WarningAlert } from 'assets/bosta-icons/alert-triangle.svg';

import './TeamsMemberAnnouncement.less';

const TeamsMemberAnnouncement = (props) => {
  const [skip, setSkip] = useState(false);
  const { close, intl, onSuccess, mobileScreenSizes } = props;
  const { isSmallMobileScreen } = mobileScreenSizes;

  const handleNextStep = useCallback(
    (skip) => {
      if (!skip) {
        onSuccess();
      }
      close();
    },
    [close, onSuccess]
  );

  useEffect(() => {
    localStorage.setItem('TeamsAnnouncementShown', true);
  }, []);

  const handleOnSkip = useCallback(() => {
    setSkip(true);
  }, [setSkip]);

  return (
    <Modal
      className="br-teams-member-announcement"
      {...props}
      title={null}
      footer={null}
      width={null}
    >
      <div className="br-teams-member-announcement__modal">
        <div className="br-teams-member-announcement__modal__content">
          <div>
            <Icon component={TeamsMemberAnnouncementBanner} />
          </div>
          <div className="br-teams-member-announcement__modal__content_title">
            <BRContentHeader
              title={intl.formatMessage({
                id: 'settings.teams_members.announcement_modal.title'
              })}
              subtitle={intl.formatMessage({
                id: skip
                  ? 'settings.teams_members.announcement_modal.next_sub_title'
                  : 'settings.teams_members.announcement_modal.sub_title'
              })}
              isInternalComponent
            />
          </div>
          {skip ? (
            <BannerContent
              icon={<WarningAlert />}
              title={intl.formatMessage({
                id: 'settings.teams_members.announcement_modal.warning_title'
              })}
              subText={intl.formatMessage({
                id: 'settings.teams_members.announcement_modal.warning_sub_title'
              })}
              extraRender={
                <div className="br-teams-member-announcement__modal__content__buttons">
                  <Button
                    className="br-teams-member-announcement__modal__content__add-team"
                    onClick={() => {
                      sendSegment('E_TEAM_MEMBERS_MODAL_TWO_ADD_MEMBER');
                      handleNextStep(false);
                    }}
                  >
                    {intl.formatMessage({
                      id: 'settings.teams_members.actions.add_button'
                    })}
                  </Button>
                  <Button
                    type="warning"
                    onClick={() => {
                      sendSegment('E_TEAM_MEMBERS_MODAL_TWO_SKIP');
                      handleNextStep(true);
                    }}
                  >
                    {intl.formatMessage({
                      id: 'common.skip'
                    })}
                  </Button>
                </div>
              }
              isSmallMobileScreen={isSmallMobileScreen}
            />
          ) : (
            <>
              <div class="br-teams-member-announcement__modal__content__footer">
                <BRButton
                  className="br-teams-member-announcement__modal__content__next-button ant-warning"
                  onClick={() => {
                    sendSegment('E_TEAM_MEMBERS_MODAL_ONE_ADD_MEMBER');
                    handleNextStep(false);
                  }}
                  type="primary"
                  label={intl.formatMessage({
                    id: `settings.teams_members.announcement_modal.buttons_add`
                  })}
                />

                <BRButton
                  onClick={() => {
                    sendSegment('E_TEAM_MEMBERS_MODAL_ONE_SKIP');
                    handleOnSkip(false);
                  }}
                  className="br-teams-member-announcement__modal__content__skip-button"
                  type="outline"
                  label={intl.formatMessage({
                    id: 'common.skip'
                  })}
                />
              </div>
            </>
          )}
        </div>
      </div>
    </Modal>
  );
};
export default mediaHook(injectIntl(withRouter(TeamsMemberAnnouncement)));
